var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('app-header',{staticClass:"flex justify-between pl-10 pr-1/10"},[_c('div',{staticClass:"flex items-center"},[_c('bot-selector',{staticClass:"w-52",attrs:{"default-bot-id":_vm.botId},on:{"change":_vm.changeBot}}),_vm._l((_vm.breadcrumbs),function(ref){
var name = ref.name;
var label = ref.label;
var component = ref.component;
var classes = ref.classes;
return _c('div',{key:name,staticClass:"flex"},[_c('span',{staticClass:"text-gray mx-5"},[_vm._v(">")]),_c(component,{tag:"component",staticClass:"text-gray-dark",class:classes,attrs:{"to":{ name: name }}},[_vm._v(" "+_vm._s(label)+" ")])],1)})],2)])}
var staticRenderFns = []

export { render, staticRenderFns }